import { render, staticRenderFns } from "./editAPI.vue?vue&type=template&id=329809bb&scoped=true&"
import script from "./editAPI.vue?vue&type=script&lang=js&"
export * from "./editAPI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329809bb",
  null
  
)

export default component.exports